export default {fields:{id:{},name:{},handle:{},avatar_url:{}},restOnlyFields:{type:{fieldResolver:'Party:type'}},typenameResolver:'PartyTypenameResolver'}